import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ExclamationCircleOutlined } from '@ant-design/icons';

interface NoPermissionProps {
  title?: string;
  description?: string;
  actionText?: string;
  onAction?: () => void;
}

const NoPermission: React.FC<NoPermissionProps> = ({
  title = '访问被拒绝',
  description = '您没有权限访问此页面，请联系管理员获取相应权限',
  actionText = '返回首页',
  onAction
}) => {
  const navigate = useNavigate();

  const handleAction = () => {
    if (onAction) {
      onAction();
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: 'calc(100vh - 200px)',
      padding: '20px'
    }}>
      <Result
        status="403"
        title={title}
        subTitle={description}
        icon={<ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />}
        extra={
          <Button
            type="primary"
            onClick={handleAction}
            size="large"
          >
            {actionText}
          </Button>
        }
      />
    </div>
  );
};

export default NoPermission;